import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  standalone: true,
  template: `<footer
    class="flex justify-between h-[45px] bg-[var(--background-primary-color)] text-[var(--text-secondary)] border-t-[1px] border-[var(--header-border)]"
  >
    <div class="flex items-center">
      <h1 class="ml-4 font-semibold">Powered By</h1>
      <img class="h-[66%] w-auto pl-2" src="./../../../assets/logo/logo_full.png" alt="logo" />
    </div>
  </footer> `,
})
export class FooterComponent {}
